var TWENTY_FOUR_HOUR_FORMAT = 'HH:mm';
var TWELVE_HOUR_FORMAT = 'hh:mm aa';
var TIME_FORMATS = [TWENTY_FOUR_HOUR_FORMAT, TWELVE_HOUR_FORMAT];
var ampmOptions = ['AM', 'PM'];
var minuteOptions = Array.from({
  length: 60 / 5
}, function (_, i) {
  return (i * 5).toString().padStart(2, '0');
});
var getHourOptions = function getHourOptions(isStandardTime) {
  if (isStandardTime) {
    return [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (hour) {
      return hour.toString().padStart(2, '0');
    });
  } else {
    return Array.from({
      length: 24
    }, function (_, i) {
      return i.toString().padStart(2, '0');
    });
  }
};
var getRegexExpression = function getRegexExpression(isStandardTime) {
  if (isStandardTime) {
    return new RegExp(/((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/);
  } else {
    return new RegExp(/^([01]\d|2[0-3]):([0-5][0-9])/);
  }
};
var regexValidation = function regexValidation(str, regex, isStandardTime) {
  // if str is empty return false
  if (str == null) {
    return [true, str];
  }
  var found = str === null || str === void 0 ? void 0 : str.match(regex);
  // Return true if the str matched the ReGex
  if (found) {
    // There need to be a space between string and AMPM
    if (isStandardTime && found[0].length === 7) {
      var formatedString = found[0].slice(0, 5) + ' ' + str.slice(5);
      return [false, formatedString.toUpperCase()];
    }
    return [false, found[0].toUpperCase()];
  } else {
    var _input$, _input$$match, _input$2, _input$2$match, _input$3, _input$4, _input$4$match, _input$5, _input$5$match, _hourTime;
    var AMPM = isStandardTime ? str.match(/[AaPp]|[Mm]/) : false;
    var input = str.split(':');
    var hourTime = isStandardTime ? (_input$ = input[0]) === null || _input$ === void 0 ? void 0 : (_input$$match = _input$.match(/^(1?[0-2]|0?[1-9])$/)) === null || _input$$match === void 0 ? void 0 : _input$$match[0] : (_input$2 = input[0]) === null || _input$2 === void 0 ? void 0 : (_input$2$match = _input$2.match(/^([0-1]?[0-9]|2[0-3])$/)) === null || _input$2$match === void 0 ? void 0 : _input$2$match[0];
    //handle the case where you dont want to type the zero every time
    if ((isStandardTime ? hourTime > 1 : hourTime > 2) && hourTime <= 9) {
      hourTime = "0".concat(parseInt(hourTime));
    }
    var minutesTime = ((_input$3 = input[1]) === null || _input$3 === void 0 ? void 0 : _input$3.length) === 1 ? (_input$4 = input[1]) === null || _input$4 === void 0 ? void 0 : (_input$4$match = _input$4.match(/[0-5]/)) === null || _input$4$match === void 0 ? void 0 : _input$4$match[0] : (_input$5 = input[1]) === null || _input$5 === void 0 ? void 0 : (_input$5$match = _input$5.match(/[0-5][0-9]/)) === null || _input$5$match === void 0 ? void 0 : _input$5$match[0];
    var regexTime = str.length > 0 ? ((_hourTime = hourTime) === null || _hourTime === void 0 ? void 0 : _hourTime.length) === 2 ? "".concat(hourTime, ":").concat(minutesTime ? minutesTime : '').concat(AMPM ? AMPM[0] : '') : "".concat(hourTime) : '';
    return [true, regexTime];
  }
};

export { TIME_FORMATS, TWELVE_HOUR_FORMAT, TWENTY_FOUR_HOUR_FORMAT, ampmOptions, getHourOptions, getRegexExpression, minuteOptions, regexValidation };
